// Layout
// import ReactPlayer from 'react-player';
import Header from 'react-scale/components/pages/transformx/header';
import Footer from 'react-scale/components/ui/footer';
import { Section, Video } from 'react-scale/components';
import Image from 'next/image';

// Sections
import Speakers from 'react-scale/components/pages/transformx/speakers';
import Hero from 'react-scale/components/pages/transformx/hero';
import PreFooter from 'react-scale/components/pages/transformx/pre-footer';
import { transformXOriginURL } from 'react-scale/lib/transformx';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';

// Data
import dato from 'react-scale/lib/dato/gql';
import { builder } from '@builder.io/sdk';
import TransformXStatsBar from 'react-scale/components/pages/transformx/stats';

builder.init('e0438815ba51486bbb6a202747122d4b');

const TransformX = ({ headerProps, page }) => (
  <ParallaxProvider>
    <div className="relative text-white bg-black">
      <div className="relative z-10 overflow-hidden text-white">
        <Header
          title="Scale TransformX Conference | Oct 19th - 21st"
          description="Join Scale AI for a two-day, virtual conference as we explore the shift from research to reality within AI and Machine Learning."
          canonical={`${transformXOriginURL}/events/transformx`}
          ogImg={`${transformXOriginURL}/static/images/pages/transformx-2022/og.jpg`}
          twImg={`${transformXOriginURL}/static/images/pages/transformx-2022/og.jpg`}
          {...headerProps}
        />
        <Hero />

        <Section bg="bg-gray-950">
          <div className="max-w-5xl mx-auto">
            <Video
              url="/static/video/pages/transformx-2022/transformx-promo-video.mp4"
              poster="/static/images/pages/transformx-2022/transformx-poster.png"
              muted={false}
              width={1920}
              height={1080}
              smallButton
            />
          </div>
        </Section>

        <div>
          <TransformXStatsBar />
        </div>
        <div className="relative z-0">
          <Speakers data={page.featuredSpeakers} useNewAvatar />

          {/* Polyhedron Background 1 */}
          <div className="absolute z-0 top-40 -right-72">
            <Parallax speed={-5}>
              <Image
                src="/static/images/transform/shape_b.jpg"
                width={440}
                height={410}
                quality={100}
                className="absolute top-0"
              />
            </Parallax>
          </div>

          {/* Polyhedron Background 2 */}
          <div className="absolute -left-64 top-1/2">
            <Parallax speed={-5}>
              <Image
                src="/static/images/transform/shape_c.jpg"
                width={400}
                height={400}
                quality={100}
                className="absolute top-0"
              />
            </Parallax>
          </div>

          {/* Polyhedron Background 3 */}
          <div className="absolute bottom-24 -right-64">
            <Parallax speed={-5}>
              <Image
                src="/static/images/transform/shape_a.jpg"
                width={465}
                height={367}
                quality={100}
                className="absolute top-0 "
              />
            </Parallax>
          </div>
        </div>
        <PreFooter />
        <Footer textColor="text-white" borderColor="border-tundora" border />
      </div>
    </div>
  </ParallaxProvider>
);

export const getStaticProps = async () => {
  const { eventTransformx } = await dato().TransformXPage();

  const builderTransformX = await builder.get('transform-x').promise();
  const transformX = builderTransformX?.data || null;

  const builderTransformXSpeakers = await builder.get('transform-x-speaker').promise();
  const speakers = builderTransformXSpeakers?.data || null;

  return {
    props: {
      page: eventTransformx,
      builderData: {
        transformX,
        speakers
      }
    },
    revalidate: 1
  };
};

export default TransformX;
